import React from 'react';
import PropTypes from 'prop-types';
import NotFound from '../../assets/img/404_not_found.svg';
import Disconnected from '../../assets/img/500_disconnected.svg';
import OtherError from '../../assets/img/other_error.svg';

import './viewer.scss';

const ErrorImage = ({ error: errorCode, sidebar }) => {
  let image = OtherError;
  if (errorCode === 500) image = Disconnected;
  if (errorCode === 404) image = NotFound;
  return (<img className={`${sidebar && 'sidebar-image'}`} src={image} alt="error message graphic" />);
};

ErrorImage.propTypes = {
  error: PropTypes.number,
  sidebar: PropTypes.bool,
};

ErrorImage.defaultProps = {
  error: null,
  sidebar: false,
};

const ErrorDisplay = ({
  error,
  message,
  sidebar,
}) => {
  return (
    <div className="error">
      <ErrorImage error={error} sidebar={sidebar} />
      <div className={`error-message ${sidebar ? 'sidebar' : ''}`}>
        {message}
      </div>
      {error
        && (
          <div className="please-try-again">
            If the problem persists,&nbsp;
            <a style={{ marginTop: 10 }} href="https://medsender.com/support" rel="noopener noreferrer" target="_blank">
              we&apos;re here to help.
            </a>
          </div>
        )}
    </div>
  );
};

ErrorDisplay.propTypes = {
  error: PropTypes.number,
  message: PropTypes.string.isRequired,
  sidebar: PropTypes.bool,
};

ErrorDisplay.defaultProps = {
  error: null,
  sidebar: false,
};

export default ErrorDisplay;
